import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const year = new Date().getFullYear();
  const { lang, changeLang, LANG_LABELS, availableLangs } = useLanguage();
  const { t } = useLanguage();
  const [showLangMenu, setShowLangMenu] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
          </svg>
          <span>Fast Boost</span>
        </div>
        <div className="footer-links">
          <Link to="/terms" className="footer-link">{t('footer.termsOfService')}</Link>
          <Link to="/order-status" className="footer-link">{t('footer.trackOrder')}</Link>
          <Link to="/status" className="footer-link">System Status</Link>
          <a href="https://telegram.fastboost.cc/" className="footer-link" target="_blank" rel="noopener noreferrer">{t('footer.telegram')}</a>
          <a href="https://discord.fastboost.cc/" className="footer-link" target="_blank" rel="noopener noreferrer">{t('footer.discord')}</a>
        </div>
        <div className="footer-right">
          <div className="footer-lang-wrapper">
            <button className="footer-lang-btn" onClick={() => setShowLangMenu(!showLangMenu)}>
              <span className="lang-flag">{LANG_LABELS[lang]?.flag}</span>
              <span>{LANG_LABELS[lang]?.label}</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{transform: showLangMenu ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s'}}><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            {showLangMenu && (
              <div className="footer-lang-menu animate-drop">
                {availableLangs.filter(l => l !== lang).map(l => (
                  <button key={l} className="footer-lang-option" onClick={() => { changeLang(l); setShowLangMenu(false); }}>
                    <span className="lang-flag">{LANG_LABELS[l]?.flag}</span>
                    <span>{LANG_LABELS[l]?.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className="footer-copyright">
            © {year} Fast Boost. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;